<template>
  <generic-modal :title="$t('shortkey profile')" ref="generic_modal">
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.name" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("path") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.path" />
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="buttons is-pulled-right">
          <div class="button is-secondary is-rounded" @click="add_shortkey">
            <span class="icon">
              <i class="fa fa-plus"></i>
            </span>
            <span>{{ $t("add") }}</span>
          </div>
        </div>

        <h5 class="title is-5 pt-3">{{ $t("shortkeys") }}</h5>
        <table
          class="table is-bordered is-fullwidth"
          v-if="meta && meta.settings.shortkeys"
        >
          <thead>
            <tr>
              <th>{{ $t("shortkey") }}</th>
              <th>{{ $t("description") }}</th>
              <th>{{ $t("execute") }}</th>
              <th>{{ $t("options") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(rsrc, ridx) in meta.settings.shortkeys" :key="ridx">
              <td>
                <input
                  type="text"
                  class="input"
                  v-model="meta.settings.shortkeys[ridx].shortkey"
                  @keydown="keydown(ridx, $event)"
                  readonly="readonly"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="input"
                  v-model="meta.settings.shortkeys[ridx].description"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="input"
                  v-model="meta.settings.shortkeys[ridx].execute"
                />
              </td>
              <td>
                <div
                  class="button is-secondary has-text-danger is-rounded"
                  @click="meta.settings.shortkeys.splice(ridx, 1)"
                  :data-tooltip="$t('delete')"
                >
                  <span class="icon">
                    <i class="fa fa-trash"></i>
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <div v-html="error"></div>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "ShortcutModal",
  components: { GenericModal },
  data() {
    return {
      meta: {
        settings: {},
      },
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name /* || !v.meta.sale_price */;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(uuid) {
      let v = this;
      v.set_initial_state();

      get("/shortkey/profile", { uuid: uuid })
        .then((element) => {
          v.meta = element;
          v.$refs.generic_modal.show_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    save() {
      let v = this;
      if (!v.meta.uuid)
        put("/shortkey/profile", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      else
        post("/shortkey/profile", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        settings: {},
      };
      v.error = "";
      // v.uuid = "";
    },
    add_shortkey() {
      let v = this;
      if (!v.meta.settings.shortkeys) v.meta.settings.shortkeys = [];
      v.meta.settings.shortkeys.push({ shortkey: "", execute: "" });
    },
    keydown(index, event) {
      let v = this;
      // console.log(
      //   event.ctrlKey,
      //   event.shiftKey,
      //   event.altKey,
      //   event.key,
      //   event.code,
      //   event.keyCode,
      //   event.which
      // );
      let name = "";
      if (event.ctrlKey) name += "ctrl+";
      if (event.shiftKey) name += "shift+";
      if (event.altKey) name += "alt+";
      name += event.key;
      if (event.key != "Tab") v.meta.settings.shortkeys[index].shortkey = name;
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
